<aurora-header auroraAppHeader [view]="'Mgmt'">
    <div slot="actions" class="d-flex align-items-center gap-2">
        <ikc-button />
        <sm-notification-icon-button></sm-notification-icon-button>
        @if (authService.getAreaKey()) {
        <div class="main-menu-dropdown" (click)="$event.stopPropagation()">
            <aurora-icon-button
                id="mainMenuButton"
                class="main-menu-button"
                variant="ghost"
                size="xlarge"
                icon="more-vertical"
                label="Main menu"
                (click)="toggleMainMenu($event)">
            </aurora-icon-button>
            @if (isMainMenuOpen) {
            <div class="main-menu-dropdown-panel">
                <sm-main-menu [view]="'Mgmt'" (itemSelected)="isMainMenuOpen = false"></sm-main-menu>
            </div>
            }
        </div>
        }
    </div>
</aurora-header>

<main>
    <router-outlet></router-outlet>
    <div *ngIf="loading" class="loading"></div>
</main>
